import { allTimeFormatObj, formatDateFunc } from '@op/utils/time';
import moment from 'moment';

export function formatTime({ date_type }: any) {
  const format = allTimeFormatObj[date_type];
  return (item: { [key: string]: any }, key: string) =>
    moment(item[key]).format(format);
}

export function formatFilterTime({ date_type }: any) {
  const formatDate = formatDateFunc(date_type);

  return (item: { [x: string]: any }, key: string | number) => {
    const time = item[key];
    return formatDate(time);
  };
}

export function formatTimeToFormat(format = 'YYYY-MM-DD HH:mm:ss') {
  return (item: { [key: string]: any }, key: string) =>
    moment(item[key]).format(format);
}
